import React from 'react';
import { Popover } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { renderRecordValue } from '../../../utils';
import styles from './index.module.css';
import { RescheduleIcon } from '../../../assets';

export const RescheduleRideIcon = ({
  tooltip = '', // Default tooltip content
  width = 15, // Default width
  height = 15, // Default height
  fill = 'var(--ant-primary-color)', // Default fill color
  text = 'Rescheduled', // Default text for renderRecordValue
  showText = true, // Conditional rendering for renderRecordValue
}) => {
    

const renderContent = () => (
  <div className={showText ? styles.leg : undefined}> 
    {/* Dynamic RescheduleIcon */}
    <RescheduleIcon fill={fill} width={width} height={height} />
    {/* Conditionally render text */}
    {showText && <span className={styles.ml_5}>{renderRecordValue(text)}</span>}
  </div>
);

return tooltip && tooltip.trim() ? (
  <Popover
    content={tooltip}
    trigger="hover"
    overlayClassName={classNames(styles.overlay)}
    getPopupContainer={(trigger) => document.body}
  >
    {renderContent()}
  </Popover>
) : (
  renderContent()
);
  
};

RescheduleRideIcon.propTypes = {
  tooltip: PropTypes.string, // Tooltip content
  width: PropTypes.number, // Icon width
  height: PropTypes.number, // Icon height
  fill: PropTypes.string, // Icon fill color
  text: PropTypes.string, // Text for renderRecordValue
  showText: PropTypes.bool, // Whether to show renderRecordValue
};
